import Axios from "../../config/axios";
import { getCurrentLanguage } from "../../helpers/Utils";

class ReportService {
  getVoucherSale = async (data) => {
    return await Axios.get("/get-sale-request", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    getTotalStock = async (data) => {
    return await Axios.get("/get-voucher-stock-request", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

      viewInvoice = async (data) => {
    return await Axios.get("/view-invoice-list", { params: data })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  downloadInvoice = async (paramdata) => {

        paramdata = {
      ...paramdata,
      language: getCurrentLanguage(),
    };
  let params = {
    params: paramdata,
  };

  if (paramdata?.isPdf) {
    params.responseType = "arraybuffer";
  }

  return await Axios.get("/download-invoice", params)
    .then(function (response) {
      const { data: data_1 } = response;

      if (paramdata?.isPdf) {
        if (paramdata?.isPreview) {
          // Convert arraybuffer to blob for preview
          const blob = new Blob([data_1], {
            type: response?.headers['content-type'] || 'application/pdf',
          });
          return blob; // Return blob instead of raw arraybuffer
        }
        
        // Original download flow
        const fileName = paramdata?.invoicenumber ? paramdata.invoicenumber: 'Invoice';
        const blob = new Blob([data_1], {
          type: response?.headers['content-type'],
        });

        saveAs(blob, fileName);
        return null; 
      } else {
        return data_1;
      }
    })
    .catch((error) => {
      console.log(error);
      throw error; 
    });
};

updateInvoice = (invoiceData) => {
  const formData = new FormData();

  Object.keys(invoiceData).forEach((key) => {
    formData.append(key, invoiceData[key]);
  });

  return Axios.post("/update-invoice-number", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};


    generateInvoice = (invoiceData) => {
    return Axios.post("/generate-invoice", invoiceData)
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

    deleteDeliveryNote = (deliverynotes) => {
      return Axios.post("/delete-delivery-note", deliverynotes)
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

}

export default new ReportService();
